<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/ImpuestosFilter.vue'
import { getImpuestosPag } from '@/services/configurations/getImpuestosPag'
import { getImpuestosExcel } from '@/services/configurations/getImpuestosExcel'
import { deleteTrashImpuesto } from '@/services/trash/deleteTrashImpuesto'
import { restoreTrashImpuesto } from '@/services/trash/restoreTrashImpuesto'

export default {
  name: 'vista-papelera-impuestos',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'impuestos',
      dialogTitle: 'Borrar impuestos',
      dialogMesage: '¿Estás seguro que deseas borrar de forma permanente los impuestos seleccionados?',
      ExcelName: 'impuestos-borrados.xlsx',
      idVista: 64,
      HeaderTitle: i18n.t('trash.impuestos'),
      vuexnamespace: 'trashImpuestos',
      PayloadSingleId: 'idImpuesto',
      PayloadMultipleId: 'idImpuestos',
      selected: []
    }
  },
  methods: {
    getParamsAux (applyFilters = false) {
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      if (applyFilters) this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      return {
        Name: data.Name ? data.Name.value : null,
        TaxType: data.TaxType ? data.TaxType.value : null,
        taxRateMin: data.taxRateMin ? data.taxRateMin.value : null,
        taxRateMax: data.taxRateMax ? data.taxRateMax.value : null,
        equivalenceSurchargeMin: data.equivalenceSurchargeMin ? data.equivalenceSurchargeMin.value : null,
        equivalenceSurchargeMax: data.equivalenceSurchargeMax ? data.equivalenceSurchargeMax.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        borrados: true,
      }
    },
    getPagAux: async function (objOrder, params) {
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      if (data.TaxCategory) {
        objOrder.listaTaxCategory = [data.TaxCategory.value]
      }
      return await getImpuestosPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      if (data.TaxCategory) {
        objOrder.listaTaxCategory = [data.TaxCategory.value]
      }
      return await getImpuestosExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashImpuesto(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashImpuesto(payload)
    }
  }
}
</script>
